// owner/app/appInfo.js
//
// What the owner app says about itself on every request (owner/app/clientHeaders.js), and its fixed links.
// The app has its own version numbers, separate from the server's v1.2.x (§2 decision 8): 1.0.0 plus an
// incrementing build number.
//
// Platform: step 9 reads it from the native shell (ios | android). Until then a browser run of the app build
// may set REACT_APP_OWNER_APP_PLATFORM so the server's app-only paths can be exercised on dev; unset, the
// platform header is simply not sent.

// True in the store app's build only (craco.config.js sets it from BUILD_TARGET). Shared owner pages read it where
// the app and the web differ: e.g. a report's «طباعة» exists on the web only.
export const IS_OWNER_APP = process.env.REACT_APP_OWNER_APP === 'true';

export const APP_INFO = {
  platform: process.env.REACT_APP_OWNER_APP_PLATFORM || '',
  version: process.env.REACT_APP_OWNER_APP_VERSION || '1.0.0',
  build: process.env.REACT_APP_OWNER_APP_BUILD || '1'
};

// «ليس لديك حساب؟» — the hostme.sa contact form, which feeds the existing lead inbox (§2 decision 10).
// The page itself, not the old /contact-us/ address that redirects to it.
export const CONTACT_URL = 'https://hostme.sa/contact/';
